import { useForm } from "react-hook-form";
import { AddIcon, DeleteIcon, EditIcon, HamburgerIcon } from '@chakra-ui/icons'
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, FormControl, FormLabel, IconButton, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDoorData } from '../context/DoorContext'

function AdminPage() {

  const { user, loading, axiosJWT, allUsers, getAllUsers } = useDoorData()
  const toast = useToast()
  const navigate = useNavigate()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenAlert, onOpen: onOpenAlert, onClose: onCloseAlert } = useDisclosure()
  const cancelRef = React.useRef()
  const { register, setValue, handleSubmit, formState: { isSubmitting }, reset } = useForm();
  const [editMode, setEditMode] = useState(false);
  const [editUser, setEditUser] = useState([]);
  const [deleteUser, setDeleteUser] = useState([]);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user])

  useEffect(() => {
    getAllUsers()

  }, [])

  useEffect(() => {
    setValue('username', editUser.login)
    setValue('email', editUser.email)

  }, [editUser])


  const onSubmit = async data => {
    if (data.repeatPassword !== data.password) {
      toast({
        title: 'Slaptažodžiai neatitinka!',
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    } else {
      try {
        const res = await axiosJWT.put("/api/users/create", { username: data.username, email: data.email, password: data.password })
        if (res) {
          toast({
            title: '👋 Naudotojas, ' + data.username + ' sukurtas!',
            position: 'bottom',
            status: 'success',
            isClosable: true,
            duration: 4000
          })
          getAllUsers();
          onClose();
          reset();

        }

      } catch (err) {
        console.log(err.response.data);
        toast({
          title: err.response.data,
          position: 'bottom',
          status: 'error',
          isClosable: true,
          duration: 4000
        })
      }
    }

  };

  const onEdit = async data => {
    let isPasswordChanging = false;
    if (data.password) {
      isPasswordChanging = true;
    }
    if (data.repeatPassword !== data.password && isPasswordChanging) {
      toast({
        title: 'Slaptažodžiai neatitinka!',
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    } else {
      try {
        const res = await axiosJWT.put("/api/users/edit", { id: editUser.id, username: data.username, email: data.email, password: data.password, isPasswordChanging })
        if (res) {
          toast({
            title: '👋 Naudotojas, ' + data.username + ' redaguotas!',
            position: 'bottom',
            status: 'success',
            isClosable: true,
            duration: 4000
          })
          getAllUsers();
          onClose();
          setEditUser([])
          reset();

        }

      } catch (err) {
        console.log(err.response.data);
        toast({
          title: err.response.data,
          position: 'bottom',
          status: 'error',
          isClosable: true,
          duration: 4000
        })
        onClose();
        setEditUser([])
      }
    }



  };

  const handleDelete = async (userID) => {
    try {
      const res = await axiosJWT.delete(`/api/users/delete/${userID}`)
      if (res) {
        toast({
          title: '👋 Naudotojas ištrintas!',
          position: 'bottom',
          status: 'success',
          isClosable: true,
          duration: 4000
        })
        getAllUsers();
        setDeleteUser([]);
        onCloseAlert();

      }

    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    }
  }



  return (
    <>
      <Button maxW={'12rem'} mx={'1rem'} leftIcon={<AddIcon />} onClick={() => { reset(); setEditUser([]); setEditMode(false); onOpen(); }} colorScheme={'blue'}>Pridėti naudotoją</Button>



      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>

          <ModalHeader>{!editMode ? 'Pridėti naudotoją' : 'Redaguoti naudotoją'}</ModalHeader>

          <ModalCloseButton />
          <ModalBody m={'1rem'}>
            {loading ?
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='green.500'
                size='xl'
              />
              :
              <form onSubmit={!editMode ? handleSubmit(onSubmit) : handleSubmit(onEdit)}>
                <FormControl maxW={'30rem'} >
                  <FormLabel>Slapyvardis</FormLabel>
                  <Input autoComplete="off" mb={'1rem'} id='username' {...register("username", { required: true })} name='username' type='text' />
                  <FormLabel>El. paštas</FormLabel>
                  <Input autoComplete="off" mb={'1rem'} id='email' {...register("email", { required: true, pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i })} name='email' type='text' />
                  {editMode && <Text mb={'0.5rem'} bg={'tomato'} color={'white'} p={'1rem'} size={'xs'} fontWeight={'300'}>Palikite slaptažodžio laukus tušcius, jeigu nenorite pakeisti naudotojo slaptažodžio.</Text>}
                  <FormLabel>{!editMode ? 'Slaptažodis' : 'Naujas slaptažodis'}</FormLabel>
                  <Input autoComplete="new-password" mb={'1rem'} id='password' {...register("password", !editMode ? { minLength: 5, required: true } : { minLength: 5, required: false })} name='password' type='password' />
                  <FormLabel>Pakartokite slaptažodi</FormLabel>
                  <Input autoComplete="new-password" id='repeatPassword' {...register("repeatPassword", !editMode ? { minLength: 5, required: true } : { minLength: 5, required: false })} name='repeatPassword' type='password' />
                  <Button mt={'1rem'} width={'100%'} colorScheme={'green'} isLoading={isSubmitting} type={'submit'} >{!editMode ? 'Pridėti naudotoją' : 'Redaguoti naudotoją'}</Button>
                </FormControl>
              </form>

            }




          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog
        isCentered
        isOpen={isOpenAlert}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlert}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              [{deleteUser}] Ištrinti naudotoją?
            </AlertDialogHeader>

            <AlertDialogBody>
              Ar jūs įsitikinę? Šio naudotojo susigrąžinti nebegalėsite.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseAlert}>
                Atšaukti
              </Button>
              <Button colorScheme='red' onClick={() => handleDelete(deleteUser)} ml={3}>
                Ištrinti
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>


      <>
        <TableContainer height={'70vh'} display={'block'} overflowY={'scroll'}>
          <Table variant='simple'>
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Slapyvardis</Th>
                <Th>El. pastas</Th>
                <Th>Pareigos</Th>
                <Th textAlign={'center'}>Veiksmai</Th>
              </Tr>
            </Thead>
            <Tbody>
              {allUsers.map((userRow, index) => {

                return (
                  <Tr key={index}>
                    <Td>{userRow.id}</Td>
                    <Td>{userRow.login}</Td>
                    <Td>{userRow.email}</Td>
                    <Td>{userRow.level === 1 ? 'Administratorius' : 'Naudotojas'}</Td>
                    <Td textAlign={'center'}>{userRow.level !== 1 ? <Menu>
                      <MenuButton
                        as={IconButton}
                        aria-label='Options'
                        icon={<HamburgerIcon />}
                        variant='outline'
                      />
                      <MenuList>
                        <MenuItem onClick={() => { setEditUser(userRow); setEditMode(true); onOpen(); }} icon={<EditIcon />}>
                          Redaguoti
                        </MenuItem>
                        <MenuItem onClick={() => { setDeleteUser(userRow.id); onOpenAlert() }} color={'red.500'} icon={<DeleteIcon />}>
                          Ištrinti
                        </MenuItem>
                      </MenuList>
                    </Menu> : '-'}</Td>
                  </Tr>
                )







              })}

            </Tbody>
          </Table>
        </TableContainer>



      </>



    </>
  )
}

export default AdminPage